export default __webpack_public_path__ + "static/media/progetto_caricato.01ce525c.png";